// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"272":"0cec9b10","369":"18c40b9c","499":"03c5cd36","699":"2bbab2f6","764":"d14a76ee","812":"86cda42d","888":"2b1fa3b5","924":"873d937d"}[chunkId] + ".chunk.js";
};